import { useSelector } from 'react-redux';
import { getCurrentProfileId } from '../redux/profile/profile.selectors';

const useIsProfileRecipeOwner = (recipe) => {
    const currentProfileId = useSelector(getCurrentProfileId);
    return recipe?.ownerProfileId === currentProfileId;
};

export default useIsProfileRecipeOwner;
